import { render } from "./projectBlock.vue?vue&type=template&id=34cd1bcc&scoped=true"
import script from "./projectBlock.vue?vue&type=script&lang=js"
export * from "./projectBlock.vue?vue&type=script&lang=js"

import "./projectBlock.vue?vue&type=style&index=0&id=34cd1bcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cd1bcc"]])

export default __exports__